import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { setDimension } from '@store/noc/base/actions';
import { dimensionsListSelector } from '@store/common/dimensionList/selectors';
import { dimensionSelector } from '@store/noc/trendsData/selectors';
import { NOC_EXCLUDE_DIMENSIONS } from '@utils/constants';
import DimensionBetaLabel from '@src/components/dimension-panel-hz/dimensionSelectorPopup/DimensionBetaLabel';

const Wrapper = styled.div`
  display: inline-block;
  max-width: 360px;
`;

function DimensionDropdown() {
  const dimension = useSelector(dimensionSelector);

  const dispatch = useDispatch();

  const dimensionsList = useSelector(
    createSelector(dimensionsListSelector, (dimensionList) => {
      const options: any[] = [];
      dimensionList.forEach((d) => {
        // CDN dimension is not supported for realtime
        if (NOC_EXCLUDE_DIMENSIONS.includes(d.groupBy)) {
          return;
        }
        options.push(d);
      });
      options.sort((a, b) => a.name.localeCompare(b.name));
      return options;
    }),
  );

  const onApply = (value) => {
    dispatch(setDimension(value));
  };

  // preventing the rendering if we don' have the dimention list
  if (!dimensionsList.length) {
    return null;
  }

  return (
    <Wrapper>
      <Select
        showSearch
        value={dimension}
        onChange={onApply}
        style={{ width: 283 }}
        optionFilterProp="label"
        optionRender={(option) => (
          <DimensionBetaLabel
            name={typeof option.label === 'string' ? option.label : ''}
            groupBy={String(option.value ?? '')}
          />
        )}
        options={dimensionsList.map((d) => ({
          value: d.groupBy,
          label: d.name,
        }))}
      />
    </Wrapper>
  );
}

export default DimensionDropdown;
